/**
 * NEDISO Theme JS — Cart AJAX, Mobile Nav, Search, Recommendations
 */

(function() {
  'use strict';

  /* Header-Skript definiert ndSetCartOpen. Fehlt es, wirft der
     Cart-Button (onclick) TypeError. Guard hier, Header unangetastet.
     Dieselbe Huelle setzt aria-hidden auf #main, solange Mobilnav
     oder Cart-Drawer offen ist. Tab-Trap bleibt unten unberuehrt. */
  function ndOverlayOpen() {
    var drawer = document.getElementById('nediso-cart-drawer');
    return document.body.classList.contains('menu-open') ||
      !!(drawer && drawer.classList.contains('open'));
  }

  function ndSyncMainAria() {
    var main = document.getElementById('main');
    if (!main) return;
    if (ndOverlayOpen()) main.setAttribute('aria-hidden', 'true');
    else main.removeAttribute('aria-hidden');
  }

  function ndCartOpenFallback(open) {
    var drawer = document.getElementById('nediso-cart-drawer');
    var btn = document.querySelector('.nd-header__cart-btn');
    if (drawer) drawer.classList.toggle('open', !!open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  var origSetCartOpen = window.ndSetCartOpen;
  window.ndSetCartOpen = function (open) {
    if (typeof origSetCartOpen === 'function') origSetCartOpen(open);
    else ndCartOpenFallback(open);
    ndSyncMainAria();
  };

  var origSetMenuOpen = window.ndSetMenuOpen;
  if (typeof origSetMenuOpen === 'function') {
    window.ndSetMenuOpen = function (open) {
      origSetMenuOpen(open);
      ndSyncMainAria();
    };
  }

  /* ── Cart AJAX ─────────────────────────────────────── */

  var cartRefreshCtrl = null;

  function updateCartBadge(cart) {
    var badge = document.getElementById('cart-count');
    if (badge) {
      badge.textContent = String(cart.item_count);
      if (cart.item_count > 0) badge.removeAttribute('hidden');
      else badge.setAttribute('hidden', '');
    }
    var header = document.querySelector('.nediso-cart-drawer__header h3');
    if (header) header.textContent = 'Warenkorb (' + cart.item_count + ')';
  }

  function cartSectionsUrl() {
    var q = 'sections=cart-drawer-content';
    try {
      var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (preview) q += '&preview_theme_id=' + encodeURIComponent(preview);
    } catch (err) { /* ignore */ }
    return '/?' + q;
  }

  function parseCartSectionHtml(text) {
    var raw = String(text || '').replace(/^\uFEFF/, '');
    var trimmed = raw.replace(/^\s+/, '');
    if (trimmed.charAt(0) !== '{') return null;
    var data;
    try { data = JSON.parse(raw); } catch (err) { return null; }
    var html = data && data['cart-drawer-content'];
    return typeof html === 'string' && html ? html : null;
  }

  function reloadOnceIfPasswordHtml(text) {
    var head = String(text || '').replace(/^\uFEFF/, '').replace(/^\s+/, '').slice(0, 240).toLowerCase();
    if (head.indexOf('<!doctype') !== 0 && head.indexOf('<html') !== 0) return;
    try {
      if (sessionStorage.getItem('nd-cart-section-reload')) return;
      sessionStorage.setItem('nd-cart-section-reload', '1');
    } catch (err) {
      return;
    }
    location.reload();
  }

  function refreshCartDrawer(cart) {
    updateCartBadge(cart);

    var keepKey = null;
    var active = document.activeElement;
    if (active && active.closest) {
      var row = active.closest('[data-key]');
      if (row) keepKey = row.getAttribute('data-key');
    }

    if (cartRefreshCtrl) cartRefreshCtrl.abort();
    cartRefreshCtrl = window.AbortController ? new AbortController() : null;

    var opts = { credentials: 'same-origin' };
    if (cartRefreshCtrl) opts.signal = cartRefreshCtrl.signal;

    return fetch(cartSectionsUrl(), opts)
      .then(function(r) { return r.text(); })
      .then(function(text) {
        var html = parseCartSectionHtml(text);
        if (!html) {
          reloadOnceIfPasswordHtml(text);
          return;
        }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.getElementById('cart-drawer-refresh');
        var current = document.getElementById('cart-drawer-refresh');
        if (!incoming || !current) return;
        current.replaceWith(document.importNode(incoming, true));

        if (keepKey) {
          var item = document.querySelector('[data-key="' + keepKey + '"]');
          if (item) {
            var btn = item.querySelector('.nediso-cart-item__qty button');
            if (btn) btn.focus();
          } else {
            var closeBtn = document.querySelector('.nediso-cart-drawer__close');
            if (closeBtn) closeBtn.focus();
          }
        }
      })
      .catch(function(e) {
        if (e && e.name === 'AbortError') return;
        console.error('Cart drawer refresh error:', e);
      });
  }

  window.updateCartItem = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (typeof cart.item_count !== 'number') {
        throw new Error(cart.description || cart.message || 'Cart change failed');
      }
      return refreshCartDrawer(cart);
    })
    .catch(function(e) { console.error('Cart update error:', e); });
  };

  // Intercept add-to-cart. Kein location.reload: Path A (PDP) bleibt stehen.
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.matches('form[action="/cart/add"]')) return;

    e.preventDefault();
    var data = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: data,
      credentials: 'same-origin'
    })
    .then(function(r) {
      return r.json().then(function(payload) {
        if (!r.ok) throw new Error(payload.description || payload.message || 'Add to cart failed');
        return payload;
      });
    })
    .then(function() {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      if (typeof cart.item_count !== 'number') throw new Error('Cart fetch failed');
      return refreshCartDrawer(cart).then(function() {
        if (typeof window.ndSetCartOpen === 'function') window.ndSetCartOpen(true);
        else {
          var drawer = document.getElementById('nediso-cart-drawer');
          if (drawer) drawer.classList.add('open');
        }
      });
    })
    .catch(function(e) { console.error('Add to cart error:', e); });
  });

  /* ── Mobile Navigation ─────────────────────────────── */

  var ND_FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function ndTrapFocus(container, e) {
    if (!container || e.key !== 'Tab') return;
    var nodes = container.querySelectorAll(ND_FOCUSABLE);
    var list = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('[hidden]')) continue;
      if (!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)) continue;
      list.push(el);
    }
    if (!list.length) {
      e.preventDefault();
      return;
    }
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    if (!container.contains(active)) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
      return;
    }
    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  }

  // Tab-Trap: Mobilnav und Cart-Drawer. Escape: Header-Skript
  // (ndSetMenuOpen / ndSetCartOpen) hat Vorrang.
  // Fallback, falls das Section-Skript fehlt.
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Tab') {
      if (document.body.classList.contains('menu-open')) {
        ndTrapFocus(document.getElementById('nediso-mobile-nav'), e);
        return;
      }
      var drawerTab = document.getElementById('nediso-cart-drawer');
      if (drawerTab && drawerTab.classList.contains('open')) {
        ndTrapFocus(drawerTab.querySelector('.nediso-cart-drawer__panel') || drawerTab, e);
      }
      return;
    }
    if (e.key !== 'Escape') return;
    if (typeof window.ndSetMenuOpen === 'function' && document.body.classList.contains('menu-open')) {
      window.ndSetMenuOpen(false);
      return;
    }
    document.body.classList.remove('menu-open');
    var search = document.getElementById('nediso-search');
    if (search) search.classList.remove('open');
    if (typeof window.ndSetCartOpen === 'function') {
      var drawer = document.getElementById('nediso-cart-drawer');
      if (drawer && drawer.classList.contains('open')) window.ndSetCartOpen(false);
    } else {
      var drawerFallback = document.getElementById('nediso-cart-drawer');
      if (drawerFallback) drawerFallback.classList.remove('open');
    }
    ndSyncMainAria();
  });

  // Mobile nav: toggle sub-menus
  document.querySelectorAll('.nediso-mobile-nav__link').forEach(function(link) {
    var group = link.parentElement;
    var sub = group.querySelector('.nediso-mobile-nav__sub');
    if (!sub) return;

    link.addEventListener('click', function(e) {
      // If has children, toggle instead of navigate
      if (sub.children.length > 0) {
        e.preventDefault();
        group.classList.toggle('open');
      }
    });
  });

  /* ── Desktop Mega Menu ─────────────────────────────── */

  var navItems = document.querySelectorAll('.nediso-nav__item.has-dropdown');
  var closeTimer;

  navItems.forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      clearTimeout(closeTimer);
      // Close other menus
      navItems.forEach(function(other) {
        if (other !== item) other.classList.remove('active');
      });
      item.classList.add('active');
    });

    item.addEventListener('mouseleave', function() {
      closeTimer = setTimeout(function() {
        item.classList.remove('active');
      }, 200);
    });
  });

  /* ── Search ────────────────────────────────────────── */

  var searchOverlay = document.getElementById('nediso-search');
  if (searchOverlay) {
    var searchInput = searchOverlay.querySelector('.nediso-search__input');

    // Focus input when search opens
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (searchOverlay.classList.contains('open') && searchInput) {
          searchInput.focus();
        }
      });
    });
    observer.observe(searchOverlay, { attributes: true, attributeFilter: ['class'] });

    // Close on click outside
    searchOverlay.addEventListener('click', function(e) {
      if (e.target === searchOverlay) {
        searchOverlay.classList.remove('open');
      }
    });
  }

  /* ── Product Page: Image Gallery ───────────────────── */

  document.querySelectorAll('.nd-pdp__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImg = document.getElementById('pdp-main');
      if (!mainImg) return;
      mainImg.src = thumb.dataset.full;
      mainImg.removeAttribute('srcset');
      document.querySelectorAll('.nd-pdp__thumb').forEach(function(t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  });

  /* ── Product Page: Variant Selector ────────────────── */

  document.querySelectorAll('.nd-pdp__variant-select').forEach(function(sel) {
    sel.addEventListener('change', function() {
      var option = this.options[this.selectedIndex];
      var box = this.closest('.nd-pdp__buybox');
      if (!option || !box) return;

      var price = Number(option.dataset.price);
      if (!Number.isSafeInteger(price) || price < 0) return;

      var priceEl = box.querySelector('.nd-price__amount');
      if (priceEl) priceEl.textContent = formatMoney(price);

      var skuEl = document.querySelector('.nd-pdp__sku');
      if (skuEl) skuEl.textContent = option.dataset.sku || '';

      var mainImg = document.getElementById('pdp-main');
      if (mainImg && option.dataset.image) {
        mainImg.src = option.dataset.image;
        mainImg.removeAttribute('srcset');
        mainImg.alt = option.dataset.alt || '';
        document.querySelectorAll('.nd-pdp__thumb').forEach(function(t) {
          t.classList.toggle('is-active', t.dataset.full === option.dataset.image);
        });
      }

      var quoteButton = document.querySelector('.nd-pdp__quote [data-anfrage-add]');
      if (quoteButton) {
        quoteButton.dataset.sku = option.dataset.sku || '';
        quoteButton.dataset.preis = formatMoney(price);
        quoteButton.dataset.titel = document.querySelector('.nd-pdp__title').textContent.trim() + ' – ' + (option.dataset.title || '');
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', this.value);
      window.history.replaceState({}, '', url);

    });
  });

  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  /* ── Product Page: Quantity Selector ────────────────── */

  document.querySelectorAll('.nediso-product__qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('.nediso-product__qty-input');
      if (!input) return;
      var val = parseInt(input.value) || 1;
      if (this.dataset.action === 'minus' && val > 1) val--;
      if (this.dataset.action === 'plus') val++;
      input.value = val;
    });
  });

  /* ── Collection: Sort ──────────────────────────────── */

  var sortSelect = document.getElementById('nediso-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* Kein Scroll-Listener. Compact (is-compact) ist abgeschaltet, .scrolled
     greift auf .nd-header nicht. Ein zweiter Listener in header.liquid
     wuerde denselben Frame zweimal layouten. */

  /* ── FAQ Accordion ─────────────────────────────────── */

  document.querySelectorAll('[data-nd-faq-list]').forEach(function(list) {
    var triggers = Array.prototype.slice.call(
      list.querySelectorAll('[data-nd-faq-trigger]')
    );

    triggers.forEach(function(btn, index) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;

      function setOpen(open) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      }

      function toggle() {
        setOpen(btn.getAttribute('aria-expanded') !== 'true');
      }

      btn.addEventListener('click', toggle);

      btn.addEventListener('keydown', function(e) {
        var key = e.key;
        if (key === ' ' || key === 'Spacebar') {
          e.preventDefault();
          toggle();
        } else if (key === 'ArrowDown') {
          e.preventDefault();
          triggers[(index + 1) % triggers.length].focus();
        } else if (key === 'ArrowUp') {
          e.preventDefault();
          triggers[(index - 1 + triggers.length) % triggers.length].focus();
        } else if (key === 'Home') {
          e.preventDefault();
          triggers[0].focus();
        } else if (key === 'End') {
          e.preventDefault();
          triggers[triggers.length - 1].focus();
        }
      });
    });
  });

  /* ── Aehnliche Artikel ──────────────────────────────
     Hier stand bis zum 09.08.2026 ein zweiter Bauplan fuer die Produktkarte,
     in JavaScript, im Praefix der Vorgaengergeneration: nediso-card mit einem
     <a> um den gesamten Inhalt, ohne Bruttopreis und ohne Anfragekorb-Knopf.

     Er lief nie: gesucht wurde #nediso-related-products, die Produktseite
     fuehrt seit dem Instrument-Umbau #nd-related. Genau deshalb ist er raus.
     Ein Bauplan, der nicht laeuft, faellt niemandem auf, bis ihn jemand
     wiederbelebt und damit die alte Kartengeneration zurueckholt.

     Wenn die Empfehlungen wiederkommen, dann ueber Shopifys Section Rendering
     API mit snippets/product-card.liquid, nicht ueber einen zweiten Bauplan.
     Echtes Zubehoer deckt sections/nediso-zubehoer.liquid bereits ab. */

})();
